import { createStore } from "@tredespace/ui/lib";

export type HudState = Readonly<{
  message: string | null;
  /** Sticky messages stay until replaced; transient ones time out. */
  sticky: boolean;
}>;

export const hudState = createStore<HudState>({ message: null, sticky: false });
